import { useEffect, useState, useRef } from 'react';
import { RoomOptionsContainer } from '../../style';
import OptionCard from 'components/OptionCard';
import { RoomType } from 'types/commonTypes';

import { useRecoilState, useResetRecoilState } from 'recoil';
import { useGetAvailableRooms } from 'customHooks/useGetAvailableRooms';
import { selectedRooms } from 'states/CheckOutStates/atoms';
import { guestQuantityState, roomQuantityState } from 'states/SearchBarStates/atoms';
import { useRecoilValue } from "recoil";

import { ROOM_TYPE_OPTIONS } from 'constants/roomTypeOptions';

const RoomOptions: React.FC = () => {

  const debug = false;

  const { searchResult, noAvailableRooms, loading } = useGetAvailableRooms()
  const [, setPersistSelectedRooms] = useRecoilState(selectedRooms)
  const clearSelectedRooms = useResetRecoilState(selectedRooms)

  const guestQuantity = useRecoilValue(guestQuantityState);
  const roomQuantity = useRecoilValue(roomQuantityState);

  const [filteredRoomTypes, setFilteredRoomTypes] = useState<RoomType[]>([]);

  const allRoomOptions = ROOM_TYPE_OPTIONS;

  const defaultRoomAppliedRef = useRef(false);

  const removeSpecificObject = (arr: RoomType[], searchArray: { searchValue: string, valuesToRemove: string[] }[]) => {
    const newArray = [...arr]
    searchArray.forEach((item) => {
      const index = newArray.findIndex(obj => obj.name === item.searchValue);
      if (index !== -1) {
        item.valuesToRemove.forEach((valueToRemove) => {
          const removeIndex = newArray.findIndex(obj => obj.name === valueToRemove);
          if (removeIndex !== -1) {
            newArray.splice(removeIndex, 1);
          }
        });
      }
    })
    return newArray
  }



  const filterSingleRooms = (arr: RoomType[]) => {
    return arr.filter(room => room.capacity !== 1)
  };


  if (debug) {
    console.log("searchResult - found rooms:", searchResult);
  }

  // const filteredRoomTypes = removeSpecificObject(searchResult, 
  //   [
  //     {searchValue: "Rook Inside", valuesToRemove: ["Rook", "Knight", "Knight Inside"]},
  //     {searchValue: "Rook", valuesToRemove: ["Knight", "Knight Inside"]},
  //     {searchValue: "Knight Inside", valuesToRemove: ["Knight"]},
  //     {searchValue: "Bishop Inside", valuesToRemove: ["Pawn Inside"]},
  //   ]
  // )

  useEffect(() => {

    /// Removing inconsistent rooms from search result

    let filteredRooms = [...searchResult];

    if (guestQuantity !== roomQuantity) {
      // We can't offer rooms with capacity: 1
      filteredRooms = filterSingleRooms(filteredRooms);
    }


    filteredRooms = removeSpecificObject(filteredRooms,
      [
        { searchValue: "Rook Inside", valuesToRemove: ["Rook", "Knight", "Knight Inside"] },
        { searchValue: "Rook", valuesToRemove: ["Knight", "Knight Inside"] },
        { searchValue: "Knight Inside", valuesToRemove: ["Knight"] },
        { searchValue: "Bishop Inside", valuesToRemove: ["Pawn Inside"] },
      ]
    )


    setFilteredRoomTypes(filteredRooms);

  }, [searchResult, guestQuantity, roomQuantity])





  useEffect(() => {
    if (noAvailableRooms) {
      localStorage.removeItem('selectedRooms')
      clearSelectedRooms()
    }
  }
    , [noAvailableRooms, clearSelectedRooms])



  // Rooms selection priority (old code):

  // const regularRoomType = filteredRoomTypes.find((roomType: RoomType) => 
  //   roomType.name === 'Rook'
  //   || roomType.name === 'Knight'
  //   || roomType.name === 'Rook Inside'
  //   || roomType.name === 'Knight Inside')

  // const queenRoomType = filteredRoomTypes.find((roomType: RoomType) =>
  //   roomType.name === 'Queen')

  // const kingRoomType = filteredRoomTypes.find((roomType: RoomType) =>
  //   roomType.name === 'King')

  // const pawnRoomType = filteredRoomTypes.find((roomType: RoomType) =>
  //   roomType.name === 'Pawn Inside')

  // useEffect(() => {

  //   const handleRoomTypeSelection = (roomType: RoomType | undefined) => {
  //     if(roomType) {
  //       const updatedRooms = {
  //         roomTypeId: roomType.roomTypeId,
  //         pricePerNight: roomType.pricePerNight,
  //         name: roomType.name,
  //         bed: roomType.bed,
  //         hasWindows: roomType.hasWindows
  //       }
  //       setPersistSelectedRooms(updatedRooms)
  //       localStorage.setItem('selectedRooms', JSON.stringify(updatedRooms))
  //     }
  //   }

  //   if(!noAvailableRooms && !filteredRoomTypes.find((roomType: RoomType) => roomType.roomTypeId === persistSelectedRooms.roomTypeId)) { 
  //     switch (true) {
  //       case !!regularRoomType:
  //         handleRoomTypeSelection(regularRoomType);
  //         break;
  //       case !!queenRoomType:
  //         handleRoomTypeSelection(queenRoomType);
  //         break;
  //       case !!kingRoomType:
  //         handleRoomTypeSelection(kingRoomType);
  //         break;
  //       case !!pawnRoomType:
  //         handleRoomTypeSelection(pawnRoomType);
  //         break;
  //       default:
  //         break;
  //     }
  //   }
  // }, [
  //   kingRoomType,
  //   queenRoomType,
  //   regularRoomType,
  //   pawnRoomType,
  //   filteredRoomTypes,
  //   persistSelectedRooms.roomTypeId,
  //   noAvailableRooms,
  //   setPersistSelectedRooms
  // ])


  // Select based on previoce user selection

  // useEffect(() => {
  //     const handleRoomTypeSelection = (roomType: RoomType | undefined) => {
  //       if (roomType) {
  //         const updatedRooms = {
  //           roomTypeId: roomType.roomTypeId,
  //           pricePerNight: roomType.pricePerNight,
  //           name: roomType.name,
  //           bed: roomType.bed,
  //           hasWindows: roomType.hasWindows
  //         };

  //         setPersistSelectedRooms(updatedRooms);
  //         localStorage.setItem('selectedRooms', JSON.stringify(updatedRooms));
  //       }
  //     };

  //     const selectedRoomStillExists = filteredRoomTypes.some(
  //       (roomType: RoomType) => roomType.roomTypeId === persistSelectedRooms.roomTypeId
  //     );

  //     if (!noAvailableRooms && !selectedRoomStillExists && filteredRoomTypes.length > 0) {
  //       handleRoomTypeSelection(filteredRoomTypes[0]);
  //     }
  //   }, [
  //     filteredRoomTypes,
  //     persistSelectedRooms.roomTypeId,
  //     noAvailableRooms,
  //     setPersistSelectedRooms
  //   ]);


  // ** Updated default room selection — it now always selects the first (most expensive) option, regardless of any previous user selection.

  useEffect(() => {
    if (noAvailableRooms || filteredRoomTypes.length === 0 || defaultRoomAppliedRef.current) {
      return;
    }

    const firstRoom = filteredRoomTypes[0];

    const updatedRooms = {
      roomTypeId: firstRoom.roomTypeId,
      pricePerNight: firstRoom.pricePerNight,
      name: firstRoom.name,
      bed: firstRoom.bed,
      hasWindows: firstRoom.hasWindows
    };

    setPersistSelectedRooms(updatedRooms);
    localStorage.setItem('selectedRooms', JSON.stringify(updatedRooms));

    defaultRoomAppliedRef.current = true;
  }, [
    filteredRoomTypes,
    noAvailableRooms,
    setPersistSelectedRooms
  ]);

  const roomArray = filteredRoomTypes.map((roomType: RoomType) => {
    const roomTypeOption = allRoomOptions[roomType.name]
    if (roomTypeOption) {
      return (
        <OptionCard
          className={roomType.name}
          key={roomType.roomTypeId}
          title={roomTypeOption.title}
          titleIcon={roomTypeOption.titleIcon}
          description={roomTypeOption.description}
          attributes={roomTypeOption.attributes}
          roomTypeId={roomType.roomTypeId}
          roomTypeName={roomType.name}
          pricePerNight={roomType.pricePerNight}
          bed={roomType.bed}
          hasWindows={roomType.hasWindows}
        />
      )
    } else {
      return null
    }
  })

  return (
    <RoomOptionsContainer>
      {noAvailableRooms && !loading ? (
        <>
          <div className="noRoomsTitle">
            The HORROR
          </div>
          <div className='noRoomsPicture'></div>
        </>
      ) : loading ? (
        <div className="loading">
          Loading...
        </div>
      ) : (
        <>
          <div className="roomOptionsTitle">
            Select your room
          </div>
          <div className="optionCardsContainer">
            {roomArray}
          </div>
          <div className="roomOptionsFooter">
            All rooms include access to our state-of-the-art fitness facility, sauna and steam room. Our hotel also features a cafe and a restaurant with options for all types of dietary needs (vegan, keto, gluten free).
          </div>
        </>
      )}
    </RoomOptionsContainer>
  );
}
export default RoomOptions;
